export const navLinks = [
  { label: '合集索引', href: '#collections' },
  { label: '当事人速览', href: '#people' },
  { label: '圈内关系', href: '#relations' },
  { label: '背景档案', href: '#dossiers' },
  { label: '事件脉络', href: '#timeline' },
  { label: '常见问题', href: '#faq' },
];

export const quickEntries = [
  { label: '合集索引', href: '#collections', icon: 'ri-layout-masonry-line' },
  { label: '当事人速览', href: '#people', icon: 'ri-user-search-line' },
  { label: '主角是谁', href: '#faq', icon: 'ri-question-line' },
];

export const updateFeed = [
  '「夜航事件」关联人物名单补充 3 人，圈内关系路径已重排',
  '「弥夏合约风波」主角身份确认，当事人档案同步更新',
  '新增专题合集：涉事方脉络对照表（含立场梳理）',
  '「星野聚会疑云」人物背景补录早年交集线索',
  '本周热度榜刷新：沈亦泽、周珩、苏晚棠位列前三',
  '「深水公关战」涉事方角色分工整理完成',
];

export const heroStats = [
  { value: '128', label: '收录当事人' },
  { value: '46', label: '专题合集' },
  { value: '312', label: '关联人物' },
  { value: '24', label: '本周更新' },
];

export const collections = [
  {
    tag: '档案合集',
    title: '当事人档案合集',
    desc: '把每起热点里的当事人单独成条，聚焦主角身份、涉事位置与背景线索，方便逐条核对。',
    count: '共 32 条',
    image: 'https://readdy.ai/api/search-image?query=abstract%20dark%20crimson%20smoke%20drifting%20over%20a%20dim%20desk%20with%20scattered%20anonymous%20folders%2C%20moody%20editorial%20low%20key%20lighting%20with%20warm%20amber%20accents%2C%20mysterious%20atmosphere%2C%20minimal%20composition%2C%20high%20detail%20artistic%20photography&width=800&height=600&seq=heila-col-01&orientation=landscape',
  },
  {
    tag: '关系合集',
    title: '圈内关系图谱合集',
    desc: '用关系路径把关联人物串起来，看清谁牵谁、谁与谁是旧识，圈内关系一眼可循。',
    count: '共 18 组',
    image: 'https://readdy.ai/api/search-image?query=abstract%20glowing%20network%20of%20thin%20crimson%20lines%20connecting%20floating%20dark%20nodes%20on%20a%20charcoal%20background%2C%20moody%20editorial%20lighting%2C%20mysterious%20atmosphere%2C%20minimal%20composition%2C%20high%20detail%20artistic%20render&width=800&height=600&seq=heila-col-02&orientation=landscape',
  },
  {
    tag: '脉络合集',
    title: '涉事方脉络合集',
    desc: '把事件里出现的各方角色、立场和动向集中对照，先分清谁在哪一环，再谈线索。',
    count: '共 21 条',
    image: 'https://readdy.ai/api/search-image?query=abstract%20group%20of%20dark%20silhouette%20figures%20standing%20apart%20in%20fog%20with%20crimson%20rim%20light%2C%20moody%20editorial%20atmosphere%2C%20deep%20shadows%2C%20minimal%20composition%2C%20high%20detail%20artistic%20photography&width=800&height=600&seq=heila-col-03&orientation=landscape',
  },
  {
    tag: '速查合集',
    title: '主角是谁速查合集',
    desc: '一句话锁定每起热点的黑料热点主角是谁，再顺着标签跳到人物背景与关联人物。',
    count: '共 27 条',
    image: 'https://readdy.ai/api/search-image?query=abstract%20single%20spotlight%20on%20an%20empty%20stage%20with%20crimson%20haze%20and%20floating%20dust%2C%20dramatic%20moody%20lighting%2C%20deep%20shadows%2C%20mysterious%20editorial%20atmosphere%2C%20minimal%20composition%2C%20high%20detail%20artistic%20photography&width=800&height=600&seq=heila-col-04&orientation=landscape',
  },
  {
    tag: '背景合集',
    title: '人物背景深挖合集',
    desc: '履历、圈层、过往交集一页读懂，把黑料热点人物背景按时间与关系两条线整理清楚。',
    count: '共 14 组',
    image: 'https://readdy.ai/api/search-image?query=abstract%20stack%20of%20aged%20blank%20documents%20and%20torn%20photographs%20under%20warm%20amber%20light%20on%20a%20dark%20surface%2C%20moody%20editorial%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20minimal%20composition%2C%20high%20detail%20artistic%20photography&width=800&height=600&seq=heila-col-05&orientation=landscape',
  },
  {
    tag: '索引合集',
    title: '关联人物索引合集',
    desc: '从关联人物反推事件线索，按关系远近与出现频次排序，冷门角色也不容易漏掉。',
    count: '共 40 条',
    image: 'https://readdy.ai/api/search-image?query=abstract%20web%20of%20thin%20crimson%20threads%20radiating%20across%20a%20dark%20textured%20wall%2C%20moody%20editorial%20lighting%2C%20mysterious%20atmosphere%2C%20minimal%20composition%2C%20high%20detail%20artistic%20photography&width=800&height=600&seq=heila-col-06&orientation=landscape',
  },
];

export const people = [
  {
    name: '沈亦泽',
    role: '当事人',
    topic: '夜航事件',
    summary: '被推上台前的当事人，圈内关系横跨两个小圈子，早年与周珩同属一个合作组，身份更像牵线者。',
    tags: ['主角候选', '旧识关系', '背景已整理'],
    heat: 96,
    image: 'https://readdy.ai/api/search-image?query=dramatic%20abstract%20silhouette%20portrait%20of%20a%20figure%20turned%20away%2C%20deep%20crimson%20gradient%20background%2C%20strong%20rim%20light%20and%20deep%20shadows%2C%20editorial%20mood%2C%20no%20facial%20detail%2C%20high%20detail%20artistic%20photography&width=600&height=600&seq=heila-person-01&orientation=squarish',
  },
  {
    name: '周珩',
    role: '涉事方',
    topic: '夜航事件',
    summary: '最早出现在时间线里的涉事方，与核心当事人存在合作与分歧两条关系线，目前立场描述仍有两种说法。',
    tags: ['早期涉事', '合作分歧', '待补齐'],
    heat: 88,
    image: 'https://readdy.ai/api/search-image?query=dramatic%20abstract%20silhouette%20profile%20of%20a%20person%20in%20warm%20amber%20backlight%2C%20dark%20charcoal%20background%2C%20editorial%20fashion%20mood%2C%20face%20kept%20in%20shadow%2C%20high%20detail%20artistic%20photography&width=600&height=600&seq=heila-person-02&orientation=squarish',
  },
  {
    name: '苏晚棠',
    role: '关联人物',
    topic: '弥夏合约风波',
    summary: '通过一次公开同框被带进讨论，与多位当事人有间接往来，是圈内关系里典型的中间节点。',
    tags: ['中间节点', '间接往来'],
    heat: 82,
    image: 'https://readdy.ai/api/search-image?query=abstract%20blurred%20stylized%20figure%20standing%20in%20a%20crowd%20of%20dark%20silhouettes%2C%20moody%20crimson%20and%20amber%20lighting%2C%20editorial%20documentary%20atmosphere%2C%20faces%20obscured%2C%20high%20detail%20artistic%20photography&width=600&height=600&seq=heila-person-03&orientation=squarish',
  },
  {
    name: '陆则屿',
    role: '当事人',
    topic: '深水公关战',
    summary: '在公关战中被反复提到的当事人之一，人物背景与两家机构的旧往来被重新翻出整理。',
    tags: ['机构往来', '背景已整理'],
    heat: 79,
    image: 'https://readdy.ai/api/search-image?query=abstract%20backlit%20figure%20wearing%20a%20long%20coat%20standing%20alone%20in%20a%20dark%20empty%20corridor%2C%20warm%20amber%20rim%20light%2C%20editorial%20cinematic%20mood%2C%20no%20visible%20face%2C%20high%20detail%20artistic%20photography&width=600&height=600&seq=heila-person-04&orientation=squarish',
  },
  {
    name: '白汐',
    role: '关联人物',
    topic: '星野聚会疑云',
    summary: '聚会名单里出现的关键关联人物，与两名当事人分别有交集，是理清圈内关系的重要一环。',
    tags: ['名单关键人', '双向交集'],
    heat: 74,
    image: 'https://readdy.ai/api/search-image?query=abstract%20dramatic%20shadow%20of%20a%20person%20cast%20on%20a%20rough%20concrete%20wall%2C%20deep%20crimson%20tinted%20lighting%2C%20minimal%20editorial%20atmosphere%2C%20mysterious%20mood%2C%20high%20detail%20artistic%20photography&width=600&height=600&seq=heila-person-05&orientation=squarish',
  },
  {
    name: '江浸月',
    role: '涉事方',
    topic: '弥夏合约风波',
    summary: '以见证者身份出现在多条线索中，所述内容与部分关联人物说法存在出入，适合对照阅读。',
    tags: ['见证者', '说法存疑'],
    heat: 69,
    image: 'https://readdy.ai/api/search-image?query=abstract%20soft%20blurred%20figure%20seen%20through%20rain%20covered%20glass%2C%20warm%20amber%20and%20crimson%20glow%2C%20editorial%20cinematic%20mood%2C%20identity%20concealed%2C%20high%20detail%20artistic%20photography&width=600&height=600&seq=heila-person-06&orientation=squarish',
  },
];

export const corePerson = {
  name: '沈亦泽',
  role: '当前核心当事人',
  topic: '夜航事件',
  intro: '出现在三条主要关系线的交汇处，被多数合集标记为「黑料热点当事人」的关键一环。',
  image: 'https://readdy.ai/api/search-image?query=abstract%20stylized%20silhouette%20of%20a%20central%20figure%20surrounded%20by%20faint%20crimson%20connecting%20lines%2C%20dark%20charcoal%20background%20with%20warm%20amber%20rim%20light%2C%20editorial%20cinematic%20mood%2C%20no%20facial%20detail%2C%20high%20detail%20artistic%20photography&width=700&height=700&seq=heila-core-01&orientation=squarish',
};

export const relationPaths = [
  { from: '沈亦泽', relation: '前合作方', to: '周珩', topic: '夜航事件', note: '早期同组合作，后期因分工产生分歧，是时间线中最早的一段关系。' },
  { from: '沈亦泽', relation: '公开同框', to: '苏晚棠', topic: '弥夏合约风波', note: '一次公开场合同框被记录，之后被当作连接两条关系线的桥梁。' },
  { from: '周珩', relation: '间接往来', to: '江浸月', topic: '弥夏合约风波', note: '两人未直接同框，通过第三方转述被关联，说法需要交叉验证。' },
  { from: '陆则屿', relation: '机构旧识', to: '沈亦泽', topic: '深水公关战', note: '机构层面的旧往来被重新整理，属于圈内关系里的隐性连接。' },
  { from: '白汐', relation: '双向交集', to: '苏晚棠', topic: '星野聚会疑云', note: '与两名当事人分别有交集，常被用来解释名单为何出现在同一场合。' },
];

export const dossiers = [
  {
    name: '沈亦泽',
    field: '夜航事件 · 核心当事人',
    background: '早期以小圈子合作身份在圈内活动，与多个关联人物存在交叉往来，人物背景以合作与旧识两条线为主。',
    highlights: ['横跨两个小圈子', '与周珩为早期同组', '曾被多次标记为主角候选'],
  },
  {
    name: '周珩',
    field: '夜航事件 · 涉事方',
    background: '最早出现在时间线中的涉事方，人物背景集中在一段长期合作经历，之后的关系走向存在两种叙述。',
    highlights: ['时间线起点人物', '合作经历较长', '立场说法待统一'],
  },
  {
    name: '苏晚棠',
    field: '弥夏合约风波 · 关联人物',
    background: '本身并非事件主角，却因与多名当事人有间接往来而被反复提及，是圈内关系图解里的中间节点。',
    highlights: ['典型中间节点', '多条关系交汇', '背景相对清晰'],
  },
  {
    name: '陆则屿',
    field: '深水公关战 · 当事人',
    background: '涉及机构层面的往来，人物背景中与两家机构的旧关系被重新梳理，涉事方角色分工也随之更新。',
    highlights: ['机构往来为主', '涉事方分工清晰', '时间跨度较长'],
  },
];

export const timeline = [
  { date: '2026-06 · 上旬', title: '事件首次被集中讨论', desc: '「夜航事件」进入公开视野，当事人与涉事方名单第一版出现，关联人物仅有少数几位。' },
  { date: '2026-06 · 下旬', title: '圈内关系被正式梳理', desc: '合集开始按关系路径整理关联人物，苏晚棠作为中间节点被加入图谱。' },
  { date: '2026-07 · 中旬', title: '主角身份出现分歧', desc: '围绕黑料热点主角是谁出现两种说法，人物背景档案随之拆分为两条叙述线。' },
  { date: '2026-08 · 上旬', title: '涉事方脉络单独成篇', desc: '各涉事方的角色与立场被拆开整理，深水公关战相关内容并入合集。' },
  { date: '2026-09 · 上旬', title: '关联人物名单补充', desc: '新增三名关联人物，圈内关系路径重排，热度榜随即刷新。' },
];

export const ranking = [
  { rank: 1, name: '沈亦泽', topic: '夜航事件', role: '当事人', score: 96 },
  { rank: 2, name: '周珩', topic: '夜航事件', role: '涉事方', score: 88 },
  { rank: 3, name: '苏晚棠', topic: '弥夏合约风波', role: '关联人物', score: 82 },
  { rank: 4, name: '陆则屿', topic: '深水公关战', role: '当事人', score: 79 },
  { rank: 5, name: '白汐', topic: '星野聚会疑云', role: '关联人物', score: 74 },
  { rank: 6, name: '江浸月', topic: '弥夏合约风波', role: '涉事方', score: 69 },
];

export const faqs = [
  {
    q: '黑料热点当事人一般指什么人？',
    a: '在这个站点里，当事人指事件中占据主要位置的个人，通常会被标记身份、涉事位置与背景线索。打开当事人页能先确认他在事件里的角色，再顺着关联人物往下看。',
  },
  {
    q: '黑料热点主角是谁？怎么快速确认？',
    a: '主角通常出现在多条关系线的交汇处。你可以先看主角是谁速查合集，再用圈内关系图谱核对，两个入口交叉验证比单看一条说法更可靠。',
  },
  {
    q: '人物背景资料是怎么整理的？',
    a: '我们按履历、圈层与过往交集三条线归档，把黑料热点人物背景写成可对照的档案条目，并标注哪些属于已整理、哪些仍待补齐。',
  },
  {
    q: '涉事方和关联人物有什么区别？',
    a: '涉事方更多是事件中承担具体角色的一方，关联人物则未必直接参与，可能只是通过往来或同框被带进来。两者在合集里会分开标注，方便区分。',
  },
  {
    q: '圈内关系怎么看才不会看乱？',
    a: '建议从一位核心当事人出发，按关系路径逐条往下看，每一条关系都会标注关系类型与对应事件，避免把不同事件的关联人物混在一起。',
  },
  {
    q: '合集内容会持续更新吗？',
    a: '会。新增的关联人物、补充的背景线索和调整后的关系路径都会同步进合集，更新条里也能看到最近一次改动的说明。',
  },
];

export const footerGroups = [
  {
    title: '浏览入口',
    links: [
      { label: '合集索引', href: '#collections' },
      { label: '当事人速览', href: '#people' },
      { label: '圈内关系', href: '#relations' },
      { label: '事件脉络', href: '#timeline' },
    ],
  },
  {
    title: '人物相关',
    links: [
      { label: '黑料热点当事人', href: '#people' },
      { label: '黑料热点主角是谁', href: '#faq' },
      { label: '黑料热点人物背景', href: '#dossiers' },
      { label: '黑料热点关联人物', href: '#collections' },
    ],
  },
  {
    title: '关系线索',
    links: [
      { label: '黑料热点涉事方', href: '#relations' },
      { label: '黑料热点圈内关系', href: '#relations' },
      { label: '热度榜', href: '#ranking' },
      { label: '常见问题', href: '#faq' },
    ],
  },
];